export default __webpack_public_path__ + "static/media/10.68fa036c.svg";